"use client"

import { FC, useCallback, useState } from "react"
import { useProjects } from "domains/wordcloudplus/hooks/useProjects"
import { ImportModal } from "./ImportModal"
import { NoProjects } from "./NoProjects"
import { ProjectCard } from "./ProjectCard"
import { ProjectsSkeleton } from "./ProjectsSkeleton"
import PageTitle from "domains/layout/components/PageTitle"
import { wordCloudsPath } from "domains/wordcloudplus/config"
import { Button } from "@ui/button"

export const WordCloudGallery: FC = () => {
    const { projects, loading, reload, exportProjects } = useProjects({
        // afterLoad,
    })
    const [importModalVisible, setImportModalVisible] = useState(false)

    const onClose = useCallback(() => {
        setImportModalVisible(false)
    }, [setImportModalVisible])

    const openImport = useCallback(() => {
        setImportModalVisible(true)
    }, [setImportModalVisible])

    const afterUpload = useCallback(() => {
        reload()
        onClose()
    }, [reload, onClose])

    return (
        <div className="flex h-full flex-col space-y-8">
            <div className="flex">
                <div className="flex-auto">
                    <PageTitle>Word Clouds</PageTitle>
                </div>
                <div className="flex-none space-x-4 place-self-end sm:mt-0 sm:ml-16">
                    {projects && projects.length > 0 && (
                        <>
                            <Button onClick={openImport} plain>
                                Import
                            </Button>
                            <Button href={`${wordCloudsPath}/new`} color="primary">
                                Create
                            </Button>
                        </>
                    )}
                </div>
            </div>
            {loading ? (
                <ProjectsSkeleton />
            ) : (
                <>
                    {projects && projects.length > 0 ? (
                        <div className="mx-auto grid grid-cols-1 gap-x-8 gap-y-20 justify-self-center md:mx-0 md:grid-cols-2 xl:grid-cols-3">
                            {projects.map((project) => {
                                return (
                                    <ProjectCard
                                        key={project.uuid}
                                        project={project}
                                        reload={reload}
                                        exportProjects={exportProjects}
                                    />
                                )
                            })}
                        </div>
                    ) : (
                        <NoProjects href={`${wordCloudsPath}/new`} openImport={openImport} />
                    )}
                </>
            )}
            <ImportModal visible={importModalVisible} onClose={onClose} afterUpload={afterUpload} />
        </div>
    )
}
